import { da, enUS, es, nl, zhCN } from "date-fns/locale";

/** date-fns locale for react-datepicker and similar. */
export function dateFnsLocaleFromI18n(lang) {
  const code = String(lang || "").toLowerCase();
  if (code === "en") return enUS;
  if (code === "ch") return zhCN;
  if (code === "dk") return da;
  if (code === "nl") return nl;
  return es;
}

/** BCP 47 tag for Intl / toLocaleString. */
export function numberLocaleFromI18n(lang) {
  const code = String(lang || "").toLowerCase();
  if (code === "en") return "en-US";
  if (code === "ch") return "zh-CN";
  if (code === "dk") return "da-DK";
  if (code === "nl") return "nl-NL";
  return "es-ES";
}

export const intlLocaleFromI18n = numberLocaleFromI18n;
